<div class="field field-horizontal-radio d-inline-flex flex-row" [class.w-100]="!optionWidth">
  @for (option of options; track option) {
    <div (click)="modelChange.emit(option.value)" [class.active]="option.value == model || (!option.value && !model)" class="field-horizontal-radio-option">
      {{option.title}}
    </div>
  }
</div>
